import React from "react";

const CvNav = () => {
  return (
      <a href="/monika_intaite_eng.pdf" target="_blank" className="cv">
        <h3>Download Resume</h3>
        <div className="cv-circle"></div>
      </a>
  );
};

export default CvNav;
